/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import { Trans } from 'react-i18next';
import i18next from '../../translations/i18n';
import API from '../../services/API';
import './index.scss';

const FilterComponent = ({ options, onChange }) => (
  <Dropdown size="lg" className="filter" autoClose="outside">
    <Dropdown.Toggle variant="outline-primary wt-outline-primary px-4">
      <span className="filter__icon" />
      <Trans>{i18next.t('Filter')}</Trans>
    </Dropdown.Toggle>
    <Dropdown.Menu
      className="p-0 w-100 shadow-lg"
      style={{ minWidth: '200px' }}
    >
      {options.map((option, id) => (
        <div key={`${option.name}-${id}`}>
          <Dropdown.Item
            eventKey={id}
            onClick={(e) => {
              e.stopPropagation();
              e.stopPropagation();
              API.sendToGA(`Filter-${option.name}`);
              onChange(id);
            }}
          >
            <Form.Check
              key={`${option.name}-${id}`}
              id={`${option.name}`}
              label={i18next.t(option.name)}
              checked={option.checked}
              className="m-0 d-flex align-items-center"
            />
          </Dropdown.Item>
          {id + 1 < options.length && (
            <Dropdown.Divider className="m-0 border" />
          )}
        </div>
      ))}
    </Dropdown.Menu>
  </Dropdown>
);

FilterComponent.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default FilterComponent;
